<template>
  <van-action-sheet
    v-model="thatShow"
    get-container="body"
    :title="contIndex === 0 ? '选择配送人员' : '配送方（自定义文案）'"
    @close="close(true)"
  >
    <div v-if="contIndex === 0">
      <div :class="_['sheet-content']">
        <van-radio-group v-model="checkPer">
          <div
            v-for="(per, index) in personList"
            :key="index"
            :class="_['check-item']"
            @click="checkPer = per.id"
          >
            <span :class="_['check-item-txt']"
              >{{ per.userName
              }}<span :class="_.phone">{{ per.userPhone }}</span></span
            >

            <van-radio :name="per.id" checked-color="#ee0a24"></van-radio>
          </div>
        </van-radio-group>
      </div>
      <div :class="[_['sheet-bottom'], _._hairlineTop]">
        <van-button round block :class="_.addbtn" @click="toAddDelivery"
          >新增配送人员</van-button
        >
        <van-button
          round
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          block
          :disabled="!checkPer"
          @click="contIndex = 1"
          >确定</van-button
        >
      </div>
    </div>
    <div v-else>
      <div :class="_['sheet-content']">
        <div :class="_.textarea">
          <van-field
            v-model="tips"
            :class="_.form"
            autosize
            type="textarea"
            maxlength="15"
            placeholder="请输入配送方案"
            show-word-limit
          />
        </div>
      </div>
      <div :class="[_['sheet-bottom'], _._hairlineTop]">
        <van-button round block :class="_.addbtn" @click="contIndex = 0"
          >选择配送人员</van-button
        >
        <van-button
          round
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          block
          @click="submit"
          >确定</van-button
        >
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
  import sheetVc from './sheetVc'
  import Vue from 'vue'
  import {
    apiOrderMerchantDeliveryUserList,
    apiOrderMerchantOrderDeliver,
  } from '@/api'
  import { Toast } from 'vant'

  export default Vue.extend({
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      orderNo: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        checkPer: '',
        thatShow: false,
        personList: [],
        contIndex: 0,
        tips: '',
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    watch: {
      show(newValue) {
        this.thatShow = newValue
        this.getUserList()
      },
    },
    methods: {
      async getUserList() {
        const result = await apiOrderMerchantDeliveryUserList(
          {},
          { hasStoreCode: true },
        )
        if (result.length !== 0) {
          this.personList = result
          this.checkPer = result[0].id
        }
      },
      close(isClose) {
        this.thatShow = false
        this.$emit('closeEmit', isClose)
      },
      toAddDelivery() {
        sheetVc.addVc = this
        this.$router.push({
          path: '/manage/deliveryperson/add',
        })
      },
      async submit() {
        Toast.loading({
          message: '发起配送中',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        })
        await apiOrderMerchantOrderDeliver(
          {
            deliverUserId: this.checkPer,
            orderNo: this.orderNo,
            tips: this.tips,
          },
          { hasStoreCode: true },
        )
        Toast.clear()
        Toast.success('发起配送成功')
        this.close()
      },
    },
  })
</script>

<style lang="scss" module>
  .sheet-content {
    max-height: 350px;
    overflow: scroll;
    padding: 20px 14px 40px 11px;
    font-size: 14px;
    .check-item {
      width: 100%;
      padding: 17px 0 17px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .check-item-txt {
        width: 308px;
        .phone {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          margin-left: 12px;
        }
      }
    }
    .textarea {
      width: calc(100% - 24px);
      background: #f4f4f4;
      border-radius: 4px;
      padding: 12px;
      .form {
        background: #f4f4f4;
        padding: 0;
      }
    }
  }
  .sheet-bottom {
    width: (100%-24) px;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    .addbtn {
      margin-right: 9px;
      border: 1px solid #ff111c;
      color: #ff111c;
    }
  }
</style>
